var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 720,
    viewBox: "0 0 720 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    rx: 32,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1010_49827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.927 121.821H163.074C145.347 121.821 130.977 136.234 130.977 154.012V296.183C130.977 313.962 145.347 328.374 163.074 328.374H556.927C574.654 328.374 589.024 313.962 589.024 296.183V154.012C589.024 136.234 574.654 121.821 556.927 121.821Z",
    stroke: "#183B56",
    strokeWidth: 1.65106,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.695 168.858H197.587C185.324 168.858 175.383 178.828 175.383 191.127V266.189C175.383 278.487 185.324 288.457 197.587 288.457H523.695C535.958 288.457 545.899 278.487 545.899 266.189V191.127C545.899 178.828 535.958 168.858 523.695 168.858Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.134 225.354H217.167C212.16 225.354 208.102 227.571 208.102 230.307V233.609C208.102 236.344 212.16 238.562 217.167 238.562H506.134C511.141 238.562 515.199 236.344 515.199 233.609V230.307C515.199 227.571 511.141 225.354 506.134 225.354Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79 230.4L143.797 591.286C143.797 603.097 153.321 612.652 165.095 612.652H560.086C571.86 612.652 581.384 603.097 581.384 591.286L506.39 230.4H513.065L589.108 590.985C589.108 590.985 591.883 620.4 566.685 620.4H160.07C160.07 620.4 136.822 617.241 140.872 594.446C144.922 571.65 215.341 230.4 215.341 230.4H218.79Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.968 229.481H506.332L581.701 592.081C581.656 603.48 572.449 612.683 561.078 612.683H163.222C151.851 612.683 142.644 603.48 142.599 592.081L217.968 229.481Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.65106
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1010_49827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.704 427.282C505.746 425.131 502.392 420.146 500.302 412.228L504.288 410.272C506.232 418.288 509.343 421.661 512.843 422.296L512.114 412.276H516.148L517.364 428.552C516.391 428.552 515.517 428.552 514.642 428.406L515.128 434.711H519.016L519.454 440.283L503.17 440.527L502.733 434.858H504.969L504.385 427.037H508.225L508.809 434.76H511.288L510.753 427.282H510.704ZM489.9 422.198L491.31 441.309H487.324L485.477 416.626L494.809 416.48L496.17 434.906H497.677L496.316 416.382H500.302L502.101 440.478L492.914 440.625L491.553 422.15H489.949L489.9 422.198Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.191 465.943L522.711 465.748L523.149 471.564L489.609 472.102L489.171 466.285L499.039 466.139L494.713 462.619C496.268 459.149 499.039 456.901 502.49 455.532C498.504 454.261 495.004 452.062 492.866 448.592L496.706 444.779C500.449 450.645 506.962 452.404 512.892 452.306H514.351L513.913 446.148H518.385L519.697 463.792H515.225L514.788 458.269H513.33C507.497 458.367 501.712 460.176 499.136 466.139L506.768 465.992L506.427 461.251H510.899L511.24 465.943H511.191ZM523.829 473.812L524.267 479.677L488.637 480.264L488.199 474.399L523.829 473.812Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.606 508.662C512.211 508.858 501.955 506.072 493.205 489.6L497.58 485.788C501.225 492.729 504.968 496.834 509.149 499.18L507.204 486.912L512.405 486.081L514.301 501.184C515.857 501.575 517.412 501.771 519.113 501.917L518.093 488.379L523.002 488.281L524.509 508.662H524.606ZM514.787 526.649L509.732 526.747L509.294 520.833L489.851 521.126L489.316 514.234L528.641 513.599L529.175 520.491L514.35 520.735L514.787 526.649Z",
    fill: "#4073F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.836 528.457L504.336 575.281L498.406 575.379L494.906 528.555L500.836 528.457ZM517.655 570.1L511.919 570.198L509.197 533.687L532.286 533.296L534.96 569.465L529.175 569.563L527.085 541.312L515.516 541.507L517.655 570.1Z",
    fill: "#4073F4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.038 228.656V248.425C422.038 256.909 415.241 263.726 406.783 263.726H377.404C368.946 263.726 362.148 256.909 362.148 248.425V228.656H422.038Z",
    fill: "#FCB766"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.401 331.961L299.775 331.961L287.936 446.431L356.009 446.43L344.17 331.961L376.727 331.961L323.451 276.487L268.401 331.961Z",
    fill: "#4073F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1010_49827",
    x: 112.799,
    y: 113.234,
    width: 494.402,
    height: 543.932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.231373 0 0 0 0 0.337255 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1010_49827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1010_49827",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1010_49827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.5319,
    height: 165.106,
    fill: "white",
    transform: "translate(485.477 410.272)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCard);
export default __webpack_public_path__ + "static/media/pay_card.f13b6f5dbc3a52adb8f182eb18941be2.svg";
export { ForwardRef as ReactComponent };